module.exports = require('./DepCreditUnionArticlesAmendmentFilingView');
